module.exports = require('./DepCreditUnionArticlesAmendmentFilingView');
